import React from 'react'
import Loader from '../Loader'
import s from '../../css/profile/profile.module.css'
import ProfileInfo from './ProfileInfo'
import ProfileQuota from './ProfileQuota'
import ProfileUsage from './ProfileUsage'
import ProfileCode from './ProfileCode'

const Profile = ({
	profileData,
	quotaData,
	isQuotaError,
	usageData,
	isUsageError,
	checkboxMailing,
	copyApiKey,
	isCopied,
}) => {
	return profileData ? (
		<div className={s.row}>
			<ProfileInfo
				email={profileData.email}
				apikey={profileData.token}
				checkboxMailing={checkboxMailing}
				isChecked={profileData.emailNotification}
				copyApiKey={copyApiKey}
				isCopied={isCopied}
			/>
			<ProfileQuota quotaData={quotaData} isQuotaError={isQuotaError} />
			<ProfileUsage usageData={usageData} isUsageError={isUsageError} />
			<ProfileCode token={profileData.token} />
		</div>
	) : (
		<Loader />
	)
}

export default Profile
